import React from 'react';
import ReactDOM from 'react-dom'; // Change from react-dom/client
import HomePage from './pages/HomePage';
import './styles/index.css'; // Corrected import for global styles
import { ErrorBoundary } from './App'; // Import ErrorBoundary
import { setupGlobalErrorHandler } from './utils/globalErrorHandling'; // Import global error handler setup
import MainLayout from './components/layouts/MainLayout'; // Import MainLayout
// import { loadAdSdkDynamically } from './utils/adLoader';

// Setup global error handling first
setupGlobalErrorHandler();

// Any other global setup/context providers needed specifically for this page, 
// but try to keep it minimal. Shared components are handled by the bundler.

// loadAdSdkDynamically();

const rootElement = document.getElementById('root');
if (rootElement) {
  // const root = ReactDOM.createRoot(rootElement); // Remove React 18 API
  // root.render( // Remove React 18 API
  ReactDOM.render( // Use React 17 API
    <React.StrictMode>
      <ErrorBoundary> {/* Wrap page component with ErrorBoundary */}
        <MainLayout shouldLoadAdSdk={true}> {/* Wrap HomePage with MainLayout and pass prop */}
          <HomePage />
        </MainLayout>
      </ErrorBoundary>
    </React.StrictMode>,
    rootElement // Pass rootElement directly
  );
} else {
  console.error('Target root element not found for HomePage');
}

// Log page load timing
console.log(`HomePage initialized: ${new Date().toISOString()}`); 